import api from './request';

/**
 * Get all menus
 *
 * @return {*}
 */
export const getAllMenuItemsRequest = (params) => api
    .request('menuitem')
    .withParams(params)
    .get();

/**
 * Get menu by Id
 *
 * @param id
 * @return {*}
 */
export const getMenuItemRequest = (id) => api
    .request(`menus/${id}`)
    .get();
